module.exports = __webpack_public_path__ + "static/media/delivery.e5ff397c.svg";